import logo from "./logo.svg";
import "./App.css";
import AccountModal from "./components/header";
import clearData from "./utils/clearData";

function App() {
  clearData();
  return (
    <div className="App">
      <AccountModal />
    </div>
  );
}

export default App;
